// extracted by mini-css-extract-plugin
export var cardSelected = "_h0-2";
export var image = "_h0-1";
export var table = "_h0-0";